<template>
	<div class="person-choise">
		<div class="container">
			<b-card no-body class="mb-2">
				<b-card-header header-tag="header" class="p-0" role="tab">
					<div
						v-b-toggle="collapseCardId"
						class="accordeon-participant-pane"
						:class="{
							ready: isValid === true,
							'not-ready': isValid === false
						}"
					>
						{{ getFullName(formData.id, personNumber) }} - {{ getRoleName(formData.id, personNumber) }}
					</div>
				</b-card-header>
				<b-collapse :id="collapseCardId" visible class="" role="tabpanel">
					<b-card-body>
						<b-form>
							<div class="row">
								<base-field
									v-for="field in formData.fields[getStep(formData.id)]"
									:key="field.field_id"
									ref="baseFields"
									:only-type="onlyUploadExplicit"
									:field="field"
									:person-number="personNumber"
									:form-data="formData"
									@blur="onBlur"
								/>
							</div>

							<div>
								<base-field
									v-for="field in formData.fields[getStep(formData.id)]"
									:key="field.field_id"
									ref="baseFields"
									:only-type="onlyUploadAny"
									:field="field"
									:person-number="personNumber"
									:form-data="formData"
									@blur="onBlur"
								/>
							</div>
						</b-form>
					</b-card-body>
				</b-collapse>
			</b-card>
		</div>
	</div>
</template>

<script>
import BaseField from '~/components/checkout/CheckoutBaseField.vue';
import { mapGetters } from 'vuex';
import { TYPE_TO_FIELD_MAP } from '@/components/checkout/fieldTypeDictionary';
import checkoutFormStep from '@/mixins/checkoutFormStep';

export default {
	name: 'Step4PersonFieldGroup',
	components: { BaseField },
	props: [
		'formData',
		'personNumber',
		'fields',
		'currentStep',
	],
	data() {
		return {
			onlyUploadExplicit: TYPE_TO_FIELD_MAP[6],
			onlyUploadAny: TYPE_TO_FIELD_MAP[7],
		};
	},
	computed: {
		...mapGetters({
			getStep: 'checkout/getStep',
			getFullName: 'checkout/getFullName',
			getRoleName: 'checkout/getRoleName',
		}),
		collapseCardId() {
			return `collapse-card_${this.personNumber}`;
		},
	},
	mixins: [checkoutFormStep],
};
</script>

<style scoped>

</style>
